import { merge } from 'es-toolkit'

import { AuthSplitSection } from './section'
import { AuthSplitContent } from './content'
import { MainSection } from '../core/main-section'
import { LayoutSection } from '../core/layout-section'
import { HeaderSection } from '../core/header-section'
import Logo from '../../components/shared/logo/logo'
import { welcomeScreenLink } from '../../util/siteLink.helpers'
import ThemeSwitchButton from '../components/theme-switch-button'

export function AuthSplitLayout({
  sx,
  cssVars,
  children,
  slotProps,
  layoutQuery = 'md'
}) {
  const renderHeader = () => {
    const headerSlotProps = {
      container: { maxWidth: false }
    }
    const headerSlots = {
      leftArea: <Logo to={welcomeScreenLink()} />,
      rightArea: <ThemeSwitchButton />
    }
    return (
      <HeaderSection
        disableElevation
        layoutQuery={layoutQuery}
        {...slotProps?.header}
        slots={{ ...headerSlots, ...slotProps?.header?.slots }}
        slotProps={merge(headerSlotProps, slotProps?.header?.slotProps ?? {})}
        sx={[
          { position: { [layoutQuery]: 'fixed' } },
          ...(Array.isArray(slotProps?.header?.sx)
            ? slotProps?.header?.sx ?? []
            : [slotProps?.header?.sx])
        ]}
      />
    )
  }

  const renderFooter = () => null

  const renderMain = () => (
    <MainSection
      {...slotProps?.main}
      sx={[
        (theme) => ({
          [theme.breakpoints.up(layoutQuery)]: { flexDirection: 'row' }
        }),
        ...(Array.isArray(slotProps?.main?.sx)
          ? slotProps?.main?.sx ?? []
          : [slotProps?.main?.sx])
      ]}
    >
      <AuthSplitSection layoutQuery={layoutQuery} {...slotProps?.section} />
      <AuthSplitContent layoutQuery={layoutQuery} {...slotProps?.content}>
        {children}
      </AuthSplitContent>
    </MainSection>
  )

  return (
    <LayoutSection
      /** **************************************
       * @Header
       *************************************** */
      headerSection={renderHeader()}
      /** **************************************
       * @Footer
       *************************************** */
      footerSection={renderFooter()}
      /** **************************************
       * @Styles
       *************************************** */
      cssVars={{ '--layout-auth-content-width': '420px', ...cssVars }}
      sx={sx}
    >
      {renderMain()}
    </LayoutSection>
  )
}
